import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { PgProviderFeeContainer } from '../../containers/payment/PgProviderFeeContainer';
import { PAYMENT_PAGE_NAME } from '../../constants/service/app/paymentConstants';

/**
 * PG 수수료 관리 페이지.
 *
 * 정산금(정산용 컬럼)과 손익계산서(손익용 컬럼)가 같은 표에서 갈린다.
 * 어느 쪽을 건드리는지 눈에 보이게 하는 것이 이 화면의 핵심이다.
 */
const PgProviderFee = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={PAYMENT_PAGE_NAME.PG_FEE}>
      <PgProviderFeeContainer />
    </PageTemplate>
  );
};

export default PgProviderFee;
